import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

interface SubscriptionTagConfig {
  hidePaymentRequiredPopup: string[];
  showPDPA?: string[];
}

@Injectable({ providedIn: 'root' })
export class SubscriptionTagConfigService {
  private config: SubscriptionTagConfig = {
    hidePaymentRequiredPopup: [],
    showPDPA: []
  };
  private loaded = false;

  constructor(private http: HttpClient) { }

  async loadConfig(): Promise<void> {
    if (this.loaded) return;

    try {
      const config = await this.http
        .get<SubscriptionTagConfig>('assets/config/subscription-tags.json')
        .toPromise();
      if (config) {
        this.config = { ...this.config, ...config };
      }
      this.loaded = true;
    } catch (err) {
      console.warn('Failed to load subscription-tags.json config, using defaults.', err);
      this.loaded = true;
    }
  }

  hidePaymentRequiredPopup(subscriptionTag: string): boolean {
    const tag = subscriptionTag?.toLowerCase() ?? '';
    return Array.isArray(this.config.hidePaymentRequiredPopup)
      ? this.config.hidePaymentRequiredPopup.some(t => t.toLowerCase() === tag)
      : false;
  }

  showPDPA(subscriptionTag: string): boolean {
    const tag = subscriptionTag?.toLowerCase() ?? '';
    return Array.isArray(this.config.showPDPA)
      ? this.config.showPDPA.some(t => t.toLowerCase() === tag)
      : false;
  }

  async shouldShowPDPA(subscriptionTag: string): Promise<boolean> {
    await this.loadConfig();
    return this.showPDPA(subscriptionTag);
  }
}
